import { Extension } from "@codemirror/state"
import { StateField } from "@codemirror/state"
import { Decoration, DecorationSet, EditorView } from "@codemirror/view"
import { findMatchingBracket } from "./findMatchingBracket"
import { MATCHING_BRACKET_CLASS } from "@features/builder/NodeDrawer/NodeForm/NodeExpressionAccordion/expressionTheme"

/**
 * StateField that tracks selection changes and creates decorations
 * for matching brackets when a bracket character is selected
 */
const bracketSelectionField = StateField.define<DecorationSet>({
  create() {
    return Decoration.none
  },
  provide: (field) => EditorView.decorations.from(field),

  update(_decorations, transaction) {
    const newDecorations: { from: number; to: number }[] = []

    // Check each selection range (CodeMirror supports multiple selections)
    for (const range of transaction.state.selection.ranges) {
      const selectionLength = range.to - range.from

      // Only process if exactly 1 character is selected
      if (selectionLength !== 1) continue

      const selectedChar = transaction.state.doc.sliceString(range.from, range.to)

      const match = findMatchingBracket(transaction.state, range.from, selectedChar)

      if (match?.end) {
        // Collect both brackets
        newDecorations.push(
          { from: match.start.from, to: match.start.to },
          { from: match.end.from, to: match.end.to },
        )
      }
    }

    // Sort decorations by position to satisfy CodeMirror's requirement
    newDecorations.sort((a, b) => a.from - b.from)

    return Decoration.set(
      newDecorations.map((pos) =>
        Decoration.mark({ class: MATCHING_BRACKET_CLASS }).range(pos.from, pos.to),
      ),
    )
  },
})

export function bracketSelectionMatching(): Extension {
  return bracketSelectionField
}
